import { Link } from '@/shared/components';
import useNetworkInfo from '@/shared/hooks/useNetworkInfo';

export default function Footer() {
  return (
    <div className="z-10 flex h-[74px] w-full items-center justify-center border-t border-cf-gray-3-5 py-6">
      <div className="flex w-full items-center justify-between px-4 text-12 text-cf-light-3 2xl:container md:px-8">
        <div className="flex items-center gap-x-1">
          <span>{useNetworkInfo()}</span>
          <span>⋅</span>
          <span>Operated by Crosschain Association</span>
        </div>
        <div className="flex items-center gap-x-[30px]">
          <Link href="/terms">Terms of Use</Link>
          <Link href="/privacy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
}
